import { Box, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { CartDrawerButton } from '@/entities/cart';
import StoreLinks from './StoreLinks';

const StoreHeader = () => {
  const router = useRouter();

  const isCheckoutPage = router.pathname.includes('/store/checkout');

  return (
    <>
      <Flex
        display={{ base: 'none', lg: 'flex' }}
        gap={{ base: 'md', xl: '2xl' }}
      >
        <StoreLinks />
      </Flex>

      {isCheckoutPage ? (
        <Box boxSize='2rem' />
      ) : (
        <CartDrawerButton
          size='sm'
          variant='ghost'
        />
      )}
    </>
  );
};

export default StoreHeader;
